import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Grid, Header, Form, Segment, Button, Menu } from 'semantic-ui-react'
import firebase from '../../config/firebase'
import RolePermissionActions from '../../reducers/rolePermissionReducer'

import utils from '../../utils'

class RolesPermissionsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 'allModules',
      selectedModules: [],
      hasChange: false,
      updating: false,
      removing: false,
    }
  }

  componentDidMount() {
    const { loaded, moduleLoaded, getModules, getRolePermission } = this.props

    if (!loaded) getRolePermission()
    if (!moduleLoaded) getModules()
  }

  componentWillReceiveProps(nextProps) {
    const { roles } = this.props

    if (nextProps.roles !== roles) {
      this.handleRoleModule(nextProps.roles)
    }
  }

  onCheckBoxChange(moduleKey) {
    const { selectedModules } = this.state
    let newArr = []

    if (_.includes(selectedModules, moduleKey)) {
      newArr = _.filter(selectedModules, value => value !== moduleKey)
    } else {
      newArr = [...selectedModules, moduleKey]
    }

    this.setState({ selectedModules: newArr, hasChange: true })
  }

  onAddRoleClick() {
    // eslint-disable-next-line no-alert
    const prompt = window.prompt('What new role should call?', '')

    if (prompt) {
      const roleKey = firebase
        .database()
        .ref('roles')
        .push().key

      const updates = {}
      updates[`/roles/${roleKey}`] = {
        access: [],
        name: prompt,
      }

      firebase
        .database()
        .ref()
        .update(updates)
        .then(err => {
          if (err) {
            // eslint-disable-next-line no-alert
            alert(err)
          }
        })
    }
  }

  onAddModule = () => {
    const prompt = window.prompt('What new module should call?', '')

    if (prompt) {
      const module = _.snakeCase(prompt)

      const updates = {}
      updates[`/modules/${module}`] = {
        module,
        name: prompt,
      }

      firebase
        .database()
        .ref()
        .update(updates)
        .then(err => {
          if (err) {
            // eslint-disable-next-line no-alert
            alert(err)
          }
        })
    }
  }

  onUpdate() {
    const { activeTab, selectedModules } = this.state
    const updates = {}

    updates[`roles/${activeTab}/access`] = selectedModules

    this.setState({ updating: true })

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => {
        this.setState({ updating: false })
      })
  }

  onDeleteRole() {
    const { activeTab } = this.state
    const updates = {}

    updates[`roles/${activeTab}/archived`] = true

    this.setState({ removing: true })

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => {
        this.setState({ removing: false })
      })
  }

  handleRoleModule(roles) {
    const { activeTab } = this.state

    if (activeTab !== 'allModules') {
      const activeRole = roles[activeTab]
      const { access } = activeRole

      if (access) {
        this.setState({ selectedModules: access, hasChange: false })
      } else {
        this.setState({ selectedModules: [], hasChange: false })
      }
    } else {
      this.setState({ selectedModules: [], hasChange: false })
    }
  }

  handleItemClick(tab) {
    const { roles } = this.props
    this.setState({ activeTab: tab }, () => this.handleRoleModule(roles))
  }

  renderAllRoles() {
    const { roles } = this.props
    const { activeTab, updating } = this.state
    const fixedRoles = ['operator@role', 'merchant_admin@role']
    const menuItems = _.map(roles, (role, roleKey) => {
      if (role.archived || fixedRoles.includes(roleKey)) return null

      return (
        <Menu.Item
          disabled={updating}
          key={roleKey}
          name={role.name}
          active={roleKey === activeTab}
          onClick={() => this.handleItemClick(roleKey)}
        />
      )
    })

    return (
      <Menu pointing vertical>
        <Menu.Item key="header" style={{ background: '#eeeeee' }} header>
          Roles
        </Menu.Item>
        {menuItems}
      </Menu>
    )
  }

  renderAllModules() {
    const { modules } = this.props

    const columns = _.map(modules, (module, moduleKey) => {
      return (
        <Grid.Column key={moduleKey}>
          <Segment>{module.name}</Segment>
        </Grid.Column>
      )
    })

    return (
      <div>
        <div style={{ padding: '14px 14px 0px 14px' }}>
          <Header size="large">All Modules</Header>
        </div>
        <Grid columns={3} style={{ margin: 0 }}>
          {columns}
        </Grid>
      </div>
    )
  }

  renderRoleModules() {
    const { selectedModules, activeTab, removing, hasChange, updating } = this.state
    const { modules, roles } = this.props

    const columns = _.map(modules, (moduleObj, moduleKey) => {
      return (
        <Grid.Column key={moduleKey}>
          <Segment>
            <Form.Checkbox
              style={{ marginTop: 6, marginBottom: 6 }}
              label={moduleObj.name}
              key={moduleKey}
              onChange={(e, data) => this.onCheckBoxChange(moduleKey, data.checked)}
              disabled={updating}
              checked={_.includes(selectedModules, moduleObj.module)}
            />
          </Segment>
        </Grid.Column>
      )
    })

    return (
      <div>
        {roles[activeTab] && roles[activeTab].name && (
          <div style={{ padding: '14px 14px 0px 14px' }}>
            <Header size="large">{roles[activeTab].name}</Header>
          </div>
        )}
        <Grid columns={3} style={{ margin: 0 }}>
          {columns}
        </Grid>
        <div style={{ margin: '0px 14px 0px 14px' }}>
          <Button
            disabled={!hasChange || updating}
            loading={updating}
            color="black"
            onClick={() => this.onUpdate()}
          >
            Update
          </Button>
          <Button
            disabled={updating || removing}
            loading={removing}
            color="red"
            onClick={() => this.onDeleteRole()}
          >
            Delete this role
          </Button>
        </div>
      </div>
    )
  }

  renderContent() {
    const { activeTab } = this.state

    switch (activeTab) {
      case 'allModules':
        return this.renderAllModules()
      default:
        return this.renderRoleModules()
    }
  }

  render() {
    const { activeTab, updating } = this.state

    return (
      <Grid>
        <Grid.Column>
          <Segment>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: 1,
              }}
            >
              <Header style={{ margin: 0 }} size="large">
                Roles & Permissions
              </Header>
              {
                utils.helpers.isDev && (
                  <Button icon color="black" onClick={() => this.onAddModule()}>
                    Add Module
                  </Button>
                )
              }
              <Button icon color="black" onClick={() => this.onAddRoleClick()}>
                Add Role
              </Button>
            </div>

            <div className="restaurant-category-wrapper">
              <div className="role-menu-tab">
                <div>
                  <Menu pointing vertical>
                    <Menu.Item
                      disabled={updating}
                      key="allModules"
                      name="All Modules"
                      active={activeTab === 'allModules'}
                      onClick={() => this.handleItemClick('allModules')}
                    />
                  </Menu>
                </div>
                <div style={{ marginTop: 10 }}>{this.renderAllRoles()}</div>
              </div>
              <div className="restaurant-category-tab-content" style={{ display: 'block' }}>
                {this.renderContent()}
              </div>
            </div>
          </Segment>
        </Grid.Column>
      </Grid>
    )
  }
}

const mapStateToProps = ({ auth, rolePermission }) => ({
  authData: auth.data,
  roles: rolePermission.roles,
  modules: rolePermission.modules,
  loaded: rolePermission.loaded,
  moduleLoaded: rolePermission.moduleLoaded,
})

const mapDispatchToProps = dispatch => ({
  getRolePermission: () => dispatch(RolePermissionActions.getAllRoles()),
  getModules: () => dispatch(RolePermissionActions.getAllModules()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RolesPermissionsContainer)



// WEBPACK FOOTER //
// ./src/containers/permissions/index.js